import React, { lazy } from 'react';
import { Gift } from 'lucide-react';
export function BonusesSection() {
  const bonuses = [{
    number: 'Bonus 1',
    title: 'The Transition Bible',
    desc: 'The guide to connecting exercises for a seamless, professional flow.',
    image: 'https://cdn.magicpatterns.com/uploads/bRh3kvBC1UJxM36fTREd4F/a471318d-a6f9-47d9-907e-a99215164f98-mockup.webp'
  }, {
    number: 'Bonus 2',
    title: 'The Cueing Dictionary',
    desc: 'The precise phrases to correct quickly and sound like an expert.',
    image: 'https://cdn.magicpatterns.com/uploads/uupEfQvUiHPMdS3E8wVHgB/6a231977-4f94-4a66-a611-f7257b76cf1b-mockup.webp'
  }, {
    number: 'Bonus 3',
    title: 'Modifying for Injuries',
    desc: 'Safe adaptations for common pathologies and physical limitations.',
    image: 'https://cdn.magicpatterns.com/uploads/oQ95jMeQypPR7HBkEwqP9x/7899fe3e-1696-4e8a-9696-541f802674ca-mockup.webp'
  }, {
    number: 'Bonus 4',
    title: 'Class Playlist Curations',
    desc: 'Hand-picked music to set the perfect mood for every session.',
    image: 'https://cdn.magicpatterns.com/uploads/1h6xfc6JYcjh6y93JSrPU2/135b0302-0ea5-4f0b-ad2f-1267c82a84eb-mockup.webp'
  }, {
    number: 'Bonus 5',
    title: 'The Business of Pilates',
    desc: 'Protocols to increase your rates and protect your professional income.',
    image: 'https://cdn.magicpatterns.com/uploads/c81VJJSMvKo8eVEnA1zw8h/800fb7ec-4499-4aa9-a347-718fa42db9db-mockup.webp'
  }];
  return <section className="bg-pilates-cream py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden pt-[010px] pb-[010px]" data-id="element-26">
      <div className="absolute top-20 right-0 w-96 h-96 bg-pilates-sage/15 rounded-full blur-3xl pointer-events-none" data-id="element-27"></div>
      <div className="absolute bottom-20 left-0 w-96 h-96 bg-pilates-lavender/15 rounded-full blur-3xl pointer-events-none" data-id="element-28"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-29">
        <div className="text-center mb-14" data-id="element-30">
          <div className="bg-pilates-rose/15 text-pilates-rose-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em] flex items-center gap-2 w-fit mx-auto" data-id="element-31">
            <Gift className="w-4 h-4" data-id="element-32" /> 5 LUXURY BONUSES INCLUDED
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-dark leading-tight mb-4 tracking-tight" data-id="element-33">
            Plus, you'll receive{' '}
            <span className="italic text-pilates-rose" data-id="element-34">5 luxury bonuses</span>
          </h2>
          <p className="text-pilates-slate text-base sm:text-lg max-w-2xl mx-auto" data-id="element-35">
            Exclusive resources that will transform your day-to-day — included
            FREE with your pack.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-36">
          {bonuses.map((bonus, idx) => <div key={idx} className="bg-white rounded-2xl p-6 shadow-md border border-pilates-sage/15 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col" data-id="element-37">
              <div className="relative mb-5 overflow-hidden rounded-xl bg-gradient-to-br from-pilates-cream to-pilates-soft aspect-square" data-id="element-38">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" loading="lazy" decoding="async" width="400" height="400" data-id="element-39" />
                <div className="absolute top-3 left-3 bg-pilates-rose text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide shadow-md" data-id="element-40">
                  {bonus.number}
                </div>
                <div className="absolute top-3 right-3 bg-pilates-sage-dark text-white text-[10px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wider shadow-md" data-id="element-41">
                  🎁 Free
                </div>
              </div>
              <h3 className="font-display font-semibold text-pilates-dark text-lg leading-tight mb-2" data-id="element-42">
                {bonus.title}
              </h3>
              <p className="text-pilates-slate text-sm leading-relaxed" data-id="element-43">
                {bonus.desc}
              </p>
            </div>)}

          {/* Decorative card showing total value */}
          <div className="bg-gradient-to-br from-pilates-sage-dark to-pilates-dark rounded-2xl p-6 shadow-md flex flex-col items-center justify-center text-center text-white" data-id="element-44">
            <Gift className="w-12 h-12 text-pilates-cream mb-3" data-id="element-45" />
            <p className="text-white/80 text-sm uppercase tracking-wider mb-2" data-id="element-46">
              All-inclusive in
            </p>
            <p className="font-display text-3xl font-semibold text-pilates-cream mb-2" data-id="element-47">
              the 6-in-1 Pack
            </p>
            <p className="text-white/75 text-sm leading-relaxed" data-id="element-48">
              The 5 bonuses are FREE with your purchase today.
            </p>
          </div>
        </div>
      </div>
    </section>;
}